import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Planos() {
  const [userData, setUserData] = useState(null);
  const [planos] = useState([
    {
      id: 1,
      nome: 'BÁSICO',
      velocidade: '200 MB',
      preco: 68.00,
      features: ['Fibra Óptica', 'Suporte 24h', 'Sem limite de dados']
    },
    {
      id: 2,
      nome: 'COMFORT',
      velocidade: '400 MB',
      preco: 78.00,
      features: ['Fibra Óptica', 'Suporte 24h', 'Sem limite de dados', 'WiFi 5']
    },
    {
      id: 3,
      nome: 'PREMIUM',
      velocidade: '600 MB',
      preco: 88.00,
      features: ['Fibra Óptica', 'Suporte 24h', 'Sem limite de dados', 'WiFi 5', 'IP Fixo']
    },
    {
      id: 4,
      nome: 'HARDCORE GAMER',
      velocidade: '1 GB',
      preco: 128.00,
      features: ['Fibra Óptica', 'Suporte 24h', 'Sem limite de dados', 'WiFi 6', 'IP Público Dedicado']
    }
  ]);

  useEffect(() => {
    const user = localStorage.getItem('unet_user');
    if (user) {
      setUserData(JSON.parse(user));
    }
  }, []);

  return (
    <div className="planos-page">
      <div className="container">
        <div className="page-header">
          <h1>Planos Disponíveis</h1>
          <p>Escolha o plano ideal para suas necessidades</p>
        </div>

        {userData && (
          <div className="current-plan">
            <h3>Seu Plano Atual</h3>
            <div className="plan-card current">
              <div className="plan-header">
                <h4>{userData.plano}</h4>
                <span className="status-badge ativo">Ativo</span>
              </div>
              <div className="plan-info">
                <p>Vencimento: {userData.vencimento}</p>
                <p>Status: {userData.status}</p>
              </div>
            </div>
          </div>
        )}

        <div className="planos-grid">
          {planos.map((plano) => (
            <div key={plano.id} className="plan-card">
              <div className="plan-header">
                <h3>{plano.nome}</h3>
                <div className="plan-speed">{plano.velocidade}</div>
              </div>
              <div className="plan-price">
                <span className="currency">R$</span>
                <span className="amount">{plano.preco.toFixed(2)}</span>
                <span className="period">/mês</span>
              </div>
              <div className="plan-features">
                {plano.features.map((feature, index) => (
                  <div key={index} className="feature">
                    <i className="fas fa-check"></i>
                    {feature}
                  </div>
                ))}
              </div>
              <div className="plan-actions">
                {userData && userData.plano === `${plano.nome} ${plano.velocidade}` ? (
                  <button className="btn-current" disabled>Plano Atual</button>
                ) : (
                  <Link to="/central/suporte" className="btn-primary">
                    Solicitar Alteração
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="planos-info">
          <div className="info-card">
            <h3>Como alterar meu plano?</h3>
            <p>Para alterar seu plano, entre em contato conosco através do suporte. Nossa equipe irá orientá-lo sobre o processo e possíveis taxas de alteração.</p>
            <Link to="/central/suporte" className="btn-secondary">Falar com Suporte</Link>
          </div>

          <div className="info-card">
            <h3>Informações Importantes</h3>
            <ul>
              <li>Todos os planos incluem fibra óptica</li>
              <li>Suporte técnico 24 horas</li>
              <li>Sem limite de dados</li>
              <li>Instalação gratuita</li>
              <li>Fidelização de 12 meses</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Planos; 